import {
  Box,
  Flex,
  Text,
  Icon,
  VStack,
  Button,
} from "@chakra-ui/react";
import { FiTool, FiArrowLeft } from "react-icons/fi";
import { MdHistory } from "react-icons/md";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { useNavigate } from "react-router-dom";

const SystemLogs = () => {
  const navigate = useNavigate();

  return (
    <Box px={4} py={6}>
      <BreadCrumbMaker items={[{ link: "#", title: "System Logs", on: true }]} />
      
      <Flex
        direction="column"
        align="center"
        justify="center"
        minH="60vh"
        bg="white"
        borderRadius="2xl"
        p={8}
        shadow="sm"
      >
        <VStack spacing={6}>
          <Flex
            bg="orange.100"
            borderRadius="full"
            p={6}
            position="relative"
          >
            <Icon as={MdHistory} boxSize={16} color="orange.500" />
            <Flex
              position="absolute"
              bottom={1}
              right={1}
              bg="white"
              borderRadius="full"
              p={1}
            >
              <Icon as={FiTool} boxSize={5} color="orange.600" />
            </Flex>
          </Flex>

          <VStack spacing={2}>
            <Text fontSize="2xl" fontWeight="bold" color="gray.700">
              System Logs
            </Text>
            <Text fontSize="lg" color="orange.500" fontWeight="semibold">
              Under Development
            </Text>
          </VStack>

          <Text
            fontSize="md"
            color="gray.500"
            textAlign="center"
            maxW="400px"
          >
            Currently under develeopment. 
            This feature will help you track all system activities and changes.
          </Text>

          <VStack spacing={2} bg="gray.50" p={4} borderRadius="lg" w="full" maxW="400px">
            <Text fontSize="sm" fontWeight="medium" color="gray.600">
              Coming Soon:
            </Text>
            <Flex wrap="wrap" gap={2} justify="center">
              <Box bg="blue.100" color="blue.700" px={3} py={1} borderRadius="full" fontSize="sm">
                Activity Logs
              </Box>
              <Box bg="green.100" color="green.700" px={3} py={1} borderRadius="full" fontSize="sm">
                API Logs
              </Box>
              <Box bg="purple.100" color="purple.700" px={3} py={1} borderRadius="full" fontSize="sm">
                Error Tracking
              </Box>
              <Box bg="orange.100" color="orange.700" px={3} py={1} borderRadius="full" fontSize="sm">
                User Actions
              </Box>
              <Box bg="red.100" color="red.700" px={3} py={1} borderRadius="full" fontSize="sm">
                Security Events
              </Box>
            </Flex>
          </VStack>

          <Button
            leftIcon={<FiArrowLeft />}
            variant="outline"
            onClick={() => navigate("/")}
            mt={4}
          >
            Back to Dashboard
          </Button>
        </VStack>
      </Flex>
    </Box>
  );
};

export default SystemLogs;
